import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const tsByMobilePatrolRequest = createRequest(constants.tsByMobilePatrol);
export const tsByMobilePatrolSuccess = createSuccess(constants.tsByMobilePatrol);
export const tsByMobilePatrolFailure = createFailure(constants.tsByMobilePatrol);

export const requestTsByMobilePatrol = tsByMobilePatrolRequest;
